iScreenWizard.factory('WizardFeedbackRapporttype', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('wizardfeedbackrapporttype', params).then(function (response) {
                var wizardfeedbackrapporttypes = response.data;
                resolve(wizardfeedbackrapporttypes);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('wizardfeedbackrapporttype/'+id).then(function (response) {
                var wizardfeedbackrapporttype = response.data;
                resolve(wizardfeedbackrapporttype);
            }, reject);
        });
    };

    return data;
});